module.exports = __webpack_public_path__ + "static/media/v1.102d31e9.JPG";